module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/BuyReasonSection/instant-cover-6d0f309373641f19f969e01e23fcabf9.png";